import StackedPercentChart from './StackedPercentChart';
import './StackedPercentChart.scss';

export default StackedPercentChart;